import { useId } from 'react'
import { cn } from '../../lib/utils'

/**
 * Custom cloud-with-arrow upload icon for the context-materials drop zone.
 * SVG from design (viewBox 0 0 143 71). Uses useId() so defs don't clash when multiple instances exist.
 */
export function ContextUploadIcon({ className }: { className?: string }) {
  const id = useId().replace(/:/g, '')
  const p = (name: string) => `${name}-${id}`

  return (
    <svg
      width="143"
      height="71"
      viewBox="0 0 143 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('mx-auto mb-2', className)}
      aria-hidden
    >
      <path
        d="M57.6211 0.520508C66.0004 0.203047 73.709 3.59341 79.3887 9.33984L79.7021 9.65625L80.0527 9.38281C84.0318 6.27623 88.8748 4.37059 94.1445 4.1709C106.353 3.70835 115.148 11.214 117.89 19.0342L118.123 19.7002L118.674 19.2588C118.837 19.1285 119.223 18.926 119.794 18.7275C120.351 18.534 121.043 18.3586 121.786 18.2617C132.258 16.8965 142.116 25.739 142.488 38.1562V38.1572C142.675 43.8989 141.177 49.3811 137.856 53.3447C134.549 57.293 129.387 59.7897 122.117 59.5H122.098L23.2793 59.292C16.4881 58.9977 10.9038 56.6184 6.96875 52.7881C3.03095 48.955 0.715112 43.6403 0.512695 37.4248C0.107544 24.981 9.3002 14.4326 19.79 14.0352C24.0736 13.873 28.0789 15.2487 31.3506 17.709L31.8271 18.0684L32.0967 17.5361C37.0658 7.727 46.5535 0.939827 57.6211 0.520508Z"
        fill={`url(#${p('paint0_linear')})`}
        stroke="#3E6161"
      />
      <mask
        id={p('mask0')}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="57"
        y="35"
        width="29"
        height="35"
      >
        <path
          d="M85.1011 51.7695C85.6372 52.4221 85.173 53.4043 84.3284 53.4043H79.4403C78.888 53.4043 78.4403 53.852 78.4403 54.4043V68.8418C78.4403 69.3941 77.9926 69.8418 77.4403 69.8418H65.3514C64.7992 69.8418 64.3514 69.3941 64.3514 68.8418V54.4043C64.3514 53.852 63.9037 53.4043 63.3514 53.4043H58.4634C57.6188 53.4043 57.1546 52.422 57.6908 51.7695L70.6237 36.0293C71.0237 35.5424 71.769 35.5424 72.169 36.0293L85.1011 51.7695Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask={`url(#${p('mask0')})`}>
        <path
          d="M85.3521 52.0735C85.7882 52.6044 85.4106 53.4034 84.7236 53.4034H79.2541C78.8049 53.4034 78.4407 53.7675 78.4407 54.2168V69.0277C78.4407 69.4769 78.0765 69.8411 77.6273 69.8411H65.1653C64.7161 69.8411 64.3519 69.4769 64.3519 69.0277V54.2168C64.3519 53.7675 63.9877 53.4034 63.5385 53.4034H58.069C57.382 53.4034 57.0044 52.6044 57.4405 52.0735L70.7678 35.8527C71.0932 35.4567 71.6994 35.4566 72.0248 35.8527L85.3521 52.0735Z"
          fill="#D9D9D9"
        />
        <rect
          x="54.2284"
          y="33.0488"
          width="39.9683"
          height="38.569"
          rx="5.14857"
          transform="rotate(5.3955 54.2284 33.0488)"
          fill="#0A2120"
        />
        <g filter={`url(#${p('filter0')})`}>
          <ellipse cx="67.3248" cy="65.1191" rx="12.0255" ry="13.1187" transform="rotate(5.3955 67.3248 65.1191)" fill="#96FDD8" />
        </g>
        <g filter={`url(#${p('filter1')})`}>
          <path d="M78.8925 40.909C78.3203 46.9681 67.0521 57.7116 58.7721 56.9295C50.4921 56.1475 44.8852 43.8102 45.4575 37.7512C46.0297 31.6921 53.2059 27.4142 61.4859 28.1963C69.7659 28.9783 79.4648 34.85 78.8925 40.909Z" fill="#134B4E" />
        </g>
        <g filter={`url(#${p('filter2')})`}>
          <path d="M64.6552 56.8169C64.2436 61.1751 59.883 64.3277 54.9156 63.8586C49.9482 63.3894 46.255 59.4761 46.6666 55.1179C47.0783 50.7598 47.3107 32.3938 52.2781 32.8629C57.2455 33.3321 65.0668 52.4587 64.6552 56.8169Z" fill="#93DDAC" />
        </g>
        <g filter={`url(#${p('filter3')})`}>
          <circle cx="79.3654" cy="50.2252" r="14.9116" transform="rotate(5.3955 79.3654 50.2252)" fill="#225D5C" />
        </g>
        <g filter={`url(#${p('filter4')})`}>
          <ellipse cx="68.5884" cy="73.9326" rx="9.88275" ry="10.5824" transform="rotate(5.3955 68.5884 73.9326)" fill="#146558" />
        </g>
        <g filter={`url(#${p('filter5')})`}>
          <path d="M86.4481 10.321C92.1821 8.6965 98.8038 14.3446 101.238 22.9365C103.672 31.5284 100.997 39.8104 95.263 41.4349C89.5289 43.0595 66.2792 52.4284 63.8451 43.8366C61.4109 35.2447 80.714 11.9456 86.4481 10.321Z" fill="#B9DD93" />
        </g>
        <g filter={`url(#${p('filter6')})`}>
          <path d="M79.134 65.723C81.853 64.9527 85.033 67.7726 86.2368 72.0215C87.4405 76.2704 86.2122 80.3393 83.4932 81.1096C80.7742 81.88 69.7645 86.375 68.5607 82.1261C67.357 77.8771 76.415 66.4933 79.134 65.723Z" fill="#93DDA6" />
        </g>
        <g filter={`url(#${p('filter7')})`}>
          <path d="M49.2454 57.0407C51.5033 56.401 54.6487 60.5238 56.2707 66.2492C57.8928 71.9746 57.3774 77.1345 55.1195 77.7742C52.8616 78.4139 43.9055 82.8052 42.2834 77.0798C40.6613 71.3544 46.9875 57.6804 49.2454 57.0407Z" fill="#D6FFCD" />
        </g>
        <g filter={`url(#${p('filter8')})`}>
          <ellipse cx="89.4306" cy="35.4052" rx="9.88275" ry="10.5824" transform="rotate(5.3955 89.4306 35.4052)" fill="#146558" />
        </g>
        <g filter={`url(#${p('filter9')})`}>
          <path d="M73.0066 54.9353C72.5843 59.4074 68.8503 62.7125 64.6667 62.3174C60.4831 61.9222 64.6173 58.655 65.0397 54.1828C65.4621 49.7107 62.0127 45.7271 66.1963 46.1223C70.3799 46.5174 73.429 50.4631 73.0066 54.9353Z" fill="#1A897A" />
        </g>
      </g>
      <path
        d="M85.3536 52.2915C85.7854 52.8179 85.4115 53.6102 84.7314 53.6102H79.317C78.8723 53.6102 78.5117 53.9714 78.5117 54.4169V69.1045C78.5117 69.55 78.1512 69.9111 77.7065 69.9111H65.3699C64.9252 69.9111 64.5647 69.55 64.5647 69.1045V54.4169C64.5647 53.9714 64.2042 53.6102 63.7594 53.6102H58.345C57.6649 53.6102 57.2911 52.8179 57.7228 52.2915L70.916 36.2057C71.2382 35.8129 71.8383 35.8129 72.1604 36.2057L85.3536 52.2915Z"
        stroke="#3E6161"
      />
      <path
        d="M71.4846 39.1114L71.8789 39.4189L71.4846 39.1114ZM71.8 39.1114L71.4058 39.4189L71.8 39.1114ZM62.1443 51.0862L62.5385 51.3937L62.1443 51.0862ZM81.1404 51.0862L80.7461 51.3937L81.1404 51.0862ZM80.9827 51.4092V50.9092H76.5962V51.4092V51.9092H80.9827V51.4092ZM76.3962 51.6092H75.8962V67.3H76.3962H76.8962V51.6092H76.3962ZM76.1962 67.5V67H66.8423V67.5V68H76.1962V67.5ZM66.6423 67.3H67.1423V51.6092H66.6423H66.1423V67.3H66.6423ZM66.4423 51.4092V50.9092H62.302V51.4092V51.9092H66.4423V51.4092ZM62.1443 51.0862L62.5385 51.3937L71.8789 39.4189L71.4846 39.1114L71.0904 38.8038L61.75 50.7787L62.1443 51.0862ZM71.8 39.1114L71.4058 39.4189L80.7461 51.3937L81.1404 51.0862L81.5346 50.7787L72.1943 38.8038L71.8 39.1114ZM71.4846 39.1114L71.8789 39.4189C71.7588 39.5729 71.5259 39.5729 71.4058 39.4189L71.8 39.1114L72.1943 38.8038C71.914 38.4445 71.3706 38.4445 71.0904 38.8038L71.4846 39.1114ZM62.302 51.4092V50.9092C62.5518 50.9092 62.6922 51.1967 62.5385 51.3937L62.1443 51.0862L61.75 50.7787C61.3915 51.2383 61.719 51.9092 62.302 51.9092V51.4092ZM66.6423 51.6092H67.1423C67.1423 51.2226 66.8289 50.9092 66.4423 50.9092V51.4092V51.9092C66.2767 51.9092 66.1423 51.7749 66.1423 51.6092H66.6423ZM66.8423 67.5V67C67.008 67 67.1423 67.1343 67.1423 67.3H66.6423H66.1423C66.1423 67.6866 66.4557 68 66.8423 68V67.5ZM76.3962 67.3H75.8962C75.8962 67.1343 76.0306 67 76.1962 67V67.5V68C76.5828 68 76.8962 67.6866 76.8962 67.3H76.3962ZM76.5962 51.4092V50.9092C76.2096 50.9092 75.8962 51.2226 75.8962 51.6092H76.3962H76.8962C76.8962 51.7749 76.7619 51.9092 76.5962 51.9092V51.4092ZM80.9827 51.4092V51.9092C81.5656 51.9092 81.8932 51.2383 81.5346 50.7787L81.1404 51.0862L80.7461 51.3937C80.5925 51.1967 80.7329 50.9092 80.9827 50.9092V51.4092Z"
        fill="#3E6161"
      />
      <defs>
        <linearGradient id={p('paint0_linear')} x1="72.8664" y1="60" x2="76.5285" y2="-11.3119" gradientUnits="userSpaceOnUse">
          <stop stopColor="#154544" stopOpacity="0" />
          <stop offset="1" stopColor="#0D3538" />
        </linearGradient>
        {[
          { id: p('filter0'), stdDev: 3.98095 },
          { id: p('filter1'), stdDev: 3.98095 },
          { id: p('filter2'), stdDev: 3.98095 },
          { id: p('filter3'), stdDev: 3.98095 },
          { id: p('filter4'), stdDev: 4.7873 },
          { id: p('filter5'), stdDev: 4.53333 },
          { id: p('filter6'), stdDev: 3.98095 },
          { id: p('filter7'), stdDev: 3.98095 },
          { id: p('filter8'), stdDev: 3.98095 },
          { id: p('filter9'), stdDev: 3.98095 },
        ].map(({ id: filterId, stdDev }) => (
          <filter key={filterId} id={filterId} x="-50%" y="-50%" width="200%" height="200%" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation={stdDev} result="effect1_foregroundBlur" />
          </filter>
        ))}
      </defs>
    </svg>
  )
}
